import { Collection } from "@tblabs/truffle";
import { Field } from "./Field";
import { FieldType } from "./FieldType";
import { RawTableField } from "./RawTableField";
import { TableItem } from "./TableItem";


export class TableField extends Field
{
    public Type = FieldType.Table;
    public Rows = new Collection<TableItem>();

    constructor(raw: Partial<RawTableField>)
    {
        super(raw);

        this.Rows.Load(...raw.Rows?.map(x => new TableItem(x)) || []);
    }
}
